import FinanceBanner from "../components/FinanceBanner";
import OfferGrid from "../components/preference-program/OfferGrid";
import { configuration } from "../helpers/config";
import { Constants } from "../helpers/constants";
import Head from "next/head";
import PageTitle from "../components/PageTitle";
import axios from "axios";
import { useDispatch, useSelector,  } from "react-redux"
import { useEffect} from "react";
import { UPDATE_LOB_VALUE } from "../redux/ActionTypes";

const CATALOG_PAGE_CONSTANTS = Constants.catalog_page;
import {MenuFunction,FooterFunction } from '../utils/menu';
export async function getServerSideProps(context) {
  const { req } = context;
  const currentUrl = `${req.headers.host}`;
  const apiData = await axios.get(
    `${configuration.APP_URL_CONTENTS}/dealer-code?url=${currentUrl}`,
  );
  const lobData = apiData?.data?.result?.[0] || "" ;
  try {
    const Menudata = await MenuFunction(lobData?.dealerCode);
    const Footerdata = await FooterFunction(lobData?.dealerCode);
    return {
      props: {
        Menudata:Menudata,
        Footerdata:Footerdata,
      },
    };
  } catch (err) {
    console.warn(err, "Error Data"); 
    return {
      props: {
        error: true,
      },
    };
  }
}

const Catalogue = (props) => {
  
 const dispatch = useDispatch();
  const LOB_VALUE = useSelector((state) => state?.app?.LobValue);
  useEffect(() => {
    dispatch({
      type: UPDATE_LOB_VALUE,
      payload: LOB_VALUE || configuration.COMMON_MASTER_LOB,
    });
  }, []);

  const offers = [
    {
      image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/scross.png`,
  model: "SCROSS",
      btnText: CATALOG_PAGE_CONSTANTS.CTA_TITLE,
      // cardLink: `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki-s-cross.pdf`,
      cardLink: `https://store.suzuki.com.mx/business-model/scross`,
      propsArrow : `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`
  // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
},
{
      image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/DZRBG.png`,
      model: "DZIRE BOOSTERGREEN",
      btnText: CATALOG_PAGE_CONSTANTS.CTA_TITLE,
      // cardLink: `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki-dzire-boostergreen.pdf`,
      cardLink: `https://store.suzuki.com.mx/business-model/dzire`,
      propsArrow : `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`
  // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
},
{
      image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/swift_bg.png`,
  // image:`${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/swift_bg.png`,
  model: "SWIFT BOOSTERGREEN",
      btnText: CATALOG_PAGE_CONSTANTS.CTA_TITLE,
      // cardLink: `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki-swift-boostergreen.pdf`,
      cardLink: `https://store.suzuki.com.mx/business-model/swift-boostergreen`,
      propsArrow : `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`
  // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
},
{
  image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/XL7-Arena-Onix_1715666134599.webp`,
  // image: "/assets/images/catalogue/grand-vitara-bg.webp",

  // image: `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/ciaz.png`,
  model: "ERTIGA XL7 Boostergreen",
  btnText:CATALOG_PAGE_CONSTANTS.CTA_TITLE,
  // cardLink: "/assets/images/catalogue/suzuki_grandvitara.pdf",
  // cardLink : `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki-ertiga-xl7-boostergreen.pdf`,
  cardLink : `https://store.suzuki.com.mx/business-model/xl7`,
  propsArrow: `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`,
  // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
},
{
      image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/Ertiga_bg.png`,
  // image: `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/Ertiga_bg.png`,
  model: "ERTIGA BOOSTERGREEN",
      btnText: CATALOG_PAGE_CONSTANTS.CTA_TITLE,
      // cardLink: `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki_ertiga_boostergreen.pdf`,
      cardLink: `https://store.suzuki.com.mx/business-model/ertiga`,
      propsArrow : `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`
  // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
      
},
{
  image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/fronx.webp`,
  // image: `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/ciaz.png`,
  model: "FRONX BOOSTERGREEN",
  btnText: CATALOG_PAGE_CONSTANTS.CTA_TITLE,
  // cardLink: `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki_fronx.pdf`,
  cardLink: `https://store.suzuki.com.mx/business-model/fronx`,
  propsArrow: `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`,
  // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
},
{
  image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/grand-vitara-bg.webp`,
  // image: `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/ciaz.png`,
  model: "Grand Vitara Boostergreen",
  btnText:CATALOG_PAGE_CONSTANTS.CTA_TITLE,
  // cardLink: `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki_grandvitara.pdf`,
  cardLink: `https://store.suzuki.com.mx/business-model/grand-vitara`,
  propsArrow: `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`,
  // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
},




    {
      image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/swift.png`,
  model: "SWIFT",
      btnText: CATALOG_PAGE_CONSTANTS.CTA_TITLE,
      // cardLink: `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki-swift.pdf`,
      cardLink: `https://store.suzuki.com.mx/business-model/swift`,
      propsArrow : `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`
  // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,

},
{
      image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/swift_sport.png`,
  // image:`${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/swift_sport.png`,
  model: "SWIFT SPORT",
      btnText: CATALOG_PAGE_CONSTANTS.CTA_TITLE,
      // cardLink: `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki-swift-sport.pdf`,
      cardLink: `https://store.suzuki.com.mx/business-model/swift-sport`,
      propsArrow : `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`
  // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
},

{
      image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/Ignis.png`,
  model: "IGNIS",
      btnText: CATALOG_PAGE_CONSTANTS.CTA_TITLE,
      // cardLink: `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki-ignis.pdf`,
      cardLink: `	https://store.suzuki.com.mx/business-model/ignis`,
      propsArrow : `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`
  // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
},




{
      image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/baleno.png`,
  // image: `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/baleno.png`,
  model: "BALENO",
      btnText: CATALOG_PAGE_CONSTANTS.CTA_TITLE,
      // cardLink: `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki_baleno.pdf`,
      cardLink: `https://store.suzuki.com.mx/business-model/baleno`,
      propsArrow : `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`
  // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
},
{
  image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/ciaz.png`,
  // image: `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/ciaz.png`,
  model: "CIAZ",
  btnText: CATALOG_PAGE_CONSTANTS.CTA_TITLE,
  // cardLink: `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki-ciaz.pdf`,
  cardLink: `https://store.suzuki.com.mx/business-model/ciaz`,
  propsArrow : `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`
  // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
},
{
  image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/jimny.webp`,
  // image: `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/ciaz.png`,
  model: "Jimny 3 door",
  btnText: CATALOG_PAGE_CONSTANTS.CTA_TITLE,
  // cardLink: "/assets/images/catalogue/suzuki_jimny2.pdf",
  // cardLink : `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki_jimny2.pdf`,
  cardLink : `https://store.suzuki.com.mx/business-model/jimny`,

  propsArrow: `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`,
  // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
},
// {
//       image:`${configuration.IMG_STATIC_URL}assets/images/catalogue/Ertiga_XL.png`,
//   // image:`${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/Ertiga_XL.png`,
//   model: "ERTIGA XL7",
//       btnText: CATALOG_PAGE_CONSTANTS.CTA_TITLE,
//       cardLink: `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki-ertiga-xl7.pdf`,
//       propsArrow : `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`
//   // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
// },


    {
      image: `${configuration.IMG_STATIC_URL}assets/images/catalogue/jimny5door.webp`,
      // image: "/assets/images/catalogue/grand-vitara-bg.webp",

      // image: `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/ciaz.png`,
      model: "Jimny 5 door",
      btnText:CATALOG_PAGE_CONSTANTS.CTA_TITLE,
      // cardLink: "/assets/images/catalogue/suzuki_grandvitara.pdf",
      // cardLink : `${configuration.IMG_STATIC_URL}assets/images/catalogue/suzuki-jimny-5door.pdf`,
      cardLink : `https://store.suzuki.com.mx/business-model/jimny-5d`,
      propsArrow: `${configuration.IMG_STATIC_URL}assets/images/catalogue/downloadIcon.svg`,
      // propsArrow : `${configuration.STATIC_RESOURCE_URL}/assets/images/catalogue/downloadIcon.svg`,
    },
   
  ];
    return(
        <>      {" "}
        <Head>
          <meta
            name="description"
            content={`${
              process.env.NEXT_PUBLIC_COUNTRY_CODE == "MEX"
                ? "Descubre una amplia gama de accesorios Suzuki en México. Explora nuestra colección para mejorar y personalizar tu vehículo Suzuki"
                : ""
            }`}
          />
  
          <meta
            name="keywords"
            content={`${
              process.env.NEXT_PUBLIC_COUNTRY_CODE == "MEX"
                ? "Accesorios SUZUKI, Autos SUZUKI Mexico, Accesorios Mexico, Accesorios para Autos"
                : ""
            }`}
          />
        </Head>
        {/* <MenuOverlaybg /> */}
    
        {/* <PageTitle title="Services" /> */}
        <PageTitle
          title={`${
            process.env.NEXT_PUBLIC_COUNTRY_CODE == "MEX"
              ? "Accesorios Suzuki México - Explora el catálogo de accesorios Suzuki"
              : ""
          }`}
        />
            <FinanceBanner
                head= {CATALOG_PAGE_CONSTANTS.TITLE}
                image={`${configuration.IMG_STATIC_URL}assets/images/catalogue/accessoriesDeskBanner.svg`}
                imageMob={`${configuration.IMG_STATIC_URL}assets/images/catalogue/accessoriesMobBanner.svg`}
                alt="Banner"
            />

            <div className="discover-accessories container-fluid md:mt-[100px]">
                <div className="container">
                <h3 className="perfectSuzuki__container--sectionHeading">
                {CATALOG_PAGE_CONSTANTS.DISCOVER_SUZUKI_ACCESSORIES}
                </h3>
                <div className="pref-offers-wrapper grid gap-x-[30px] gap-y-[30px] md:gap-x-[50px] md:gap-y-[70px] lg:gap-x-[100px] lg:gap-y-[80px] grid-cols-2 md:grid-cols-4 lg:grid-cols-4 md:pr-[50px] lg:pr-[60px]">
            {offers.map((elem, indx) => {
              return (
                <OfferGrid
                  key={indx}
                  image={elem.image}
                  model={elem.model}
                  showCatalogue
                  propsArrow={elem.propsArrow}
                  btnText={elem.btnText}
                  cardLink={elem.cardLink}
                  hideCtas
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Catalogue;
